import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Identifiable, Project, ProjectExternalLink } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  links: ProjectExternalLink[];
  retrieveProjectExternalLinks(
    request: Boundaries["retrieveProjectExternalLinks"]["request"],
  ): void;
}

function useRetrieveProjectExternalLinks(
  project: Identifiable<Project>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRetrieveProjectExternalLinksRequestPending(project),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRetrieveProjectExternalLinksRequestSuccess(project),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRetrieveProjectExternalLinksRequestFailure(project),
    ),
    links: useSelector(() => selector.getProjectExternalLinks(project)),
    retrieveProjectExternalLinks: core.retrieveProjectExternalLinks,
  };
}

export { useRetrieveProjectExternalLinks };
